// Import of actions
import * as SupportActionActions from "../actions/support-action.actions";
import { ISupportAction } from "../../models/support-action";

export type SupportActionState = ISupportAction[];

export const initialState: ISupportAction[] = [];

export function supportActionReducer(
  state = initialState,
  action: SupportActionActions.Actions
): SupportActionState {
  switch (action.type) {
    case SupportActionActions.RESET_STATE: {
      return initialState;
    }

    case SupportActionActions.ADD: {
      return state.find(supportAction => supportAction.id === action.payload.id)
        ? state
        : [...state, action.payload];
    }

    case SupportActionActions.REPLACE: {
      return [
        ...state.filter(
          supportAction => supportAction.id !== action.payload.id
        ),
        action.payload // payload is FHIR resource
      ];
    }

    case SupportActionActions.REPLACE_MULTIPLE: {
      const replacedIds = action.payload.map(elem => elem.id)
      return [
        ...state.filter(
          item => !replacedIds.includes(item.id)
        ),
        ...action.payload // payload is FHIR resource
      ];
    }

    case SupportActionActions.UPDATE: {
      return state.map(supportAction => {
        return supportAction.id === action.payload.id
          ? { ...supportAction, ...action.payload }
          : supportAction;
      });
    }

    case SupportActionActions.DELETE: {
      return state.filter(
        supportAction => supportAction.id !== action.payload.id
      );
    }

    // We do not have a reducer for the LOAD action as it doesn't alter the state
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/support-action.reducer.ts